import React from 'react';
import PropTypes from 'prop-types';
import Block from '../../../block/Block';
import CmsContent from '../../CmsContent';
import styles from './Service';
export var Service = function Service(_ref) {
  var data = _ref.data;

  var _ref2 = data || {},
      _ref2$component = _ref2.component;

  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var metadata = _ref2$component.metadata,
      _ref2$component$conte = _ref2$component.content;
  _ref2$component$conte = _ref2$component$conte === void 0 ? {} : _ref2$component$conte;
  var cta = _ref2$component$conte.cta,
      smallText = _ref2$component$conte.small_text;

  var _ref3 = metadata || {},
      visualcta = _ref3.visualcta;

  return cta || smallText ? /*#__PURE__*/React.createElement(Block, {
    "data-en": 'cms-service',
    className: styles['cms-service-wrapper']
  }, !visualcta && cta ? /*#__PURE__*/React.createElement(CmsContent, {
    content: cta
  }, /*#__PURE__*/React.createElement(CmsContent, {
    content: smallText
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CmsContent, {
    content: cta
  }), /*#__PURE__*/React.createElement(CmsContent, {
    content: smallText
  }))) : null;
};
Service.propTypes = {
  data: PropTypes.object.isRequired
};
export default Service;